<template>
    <navigation />

    <div
        class="container mt-4"
        :class="{
            'on-trial': user.on_trial,
        }"
    >
        <div
            class="alert alert-danger d-none d-print-block"
            role="alert"
        >
            <h5>
                {{ $t('lesson.printingWarning') }}
            </h5>

            <p class="mb-0">
                {{ $t('lesson.printingInstructions') }}
            </p>
        </div>

        <lessons-list
            class="d-print-none"
            :series-id="Number($route.params.id)"
        />
    </div>

    <site-footer />
</template>

<script>
import Navigation from "../../partials/Navigation.vue";
import SiteFooter from "../../partials/SiteFooter.vue";
import LessonsList from "../../partials/subscriber/LessonsList.vue";
import axios from "axios";

export default {
    name: "SubscriberSeries",

    components: {
        LessonsList,
        Navigation,
        SiteFooter,
    },

    data() {
        return {
            user: {},
        };
    },

    head() {
        return {
            title: `${this.$app.appName} - ${this.$t("series.title")}`,
        };
    },

    mounted() {
        this.getUser();
    },

    methods: {
      getUser: function () {
            axios({
                method: 'get',
                url: '/subscriber/api/user/',
            })
            .then((response) => {
                this.user = response.data;
            });
        },
    },
};
</script>
